import { Box } from "@material-ui/core";
import { Grid, Typography } from "@mui/material";
import axios from "axios";
import { AboutUsImage, ModalError, SkeletonComponent } from "components";
import { useEffect, useState } from "react";
import { hardBaseUrl } from "services/urlConstant";
import { globalStyles } from "styles";
import { getErrors } from "utils";
import Layout from "../../../mpisLandingComponent/Layout";
import styled from "styled-components";
import bannerImage from "../../../assets/img/banner_tentang_kami.png";

export default function TentangKami() {
  const classes = globalStyles();

  const [loadingPage, setLoadingPage] = useState(false);
  const [dataContent, setDataContent] = useState({
    about_us: "",
    our_vision: "",
    about_us_images: [],
    our_vision_images: [],
    publisher_images: [],
  });
  const hostname = window.location.hostname;
  const subdomain = hostname.split(".")[0];
  const {
    about_us,
    our_vision,
    about_us_images,
    our_vision_images,
    publisher_images,
  } = dataContent;

  const getDetail = async () => {
    try {
      setLoadingPage(true);
      const res = await axios.get(
        `${hardBaseUrl}/landing/publisher/web-content`,
        { params: { subdomain } }
      );
      const { data } = res?.data;
      const groupedImages = {
        about_us: [],
        our_vision: [],
        publisher: [],
      };
      data.images?.forEach(img => {
        if (groupedImages[img.type]) {
          groupedImages[img.type].push({
            image_url: img.image_name,
            image: null,
            ...img,
          });
        }
      });

      setDataContent(prev => ({
        ...prev,
        about_us: data.about_us || "",
        our_vision: data.our_vision || "",
        about_us_images: (groupedImages.about_us || []).slice(0, 2),
        our_vision_images: groupedImages.our_vision || [],
        publisher_images: groupedImages.publisher || [],
      }));
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingPage(false);
    }
  };

  useEffect(() => {
    getDetail();
  }, []);

  return (
    <Layout>
      {loadingPage ? (
        <SkeletonComponent variant="wave" />
      ) : (
        <>
          <BannerContainer>
            <Box maxWidth="60%">
              <Typography fontSize={48} fontWeight={600} mb={2}>
                About Us
              </Typography>
              <Typography color="#687083">
                <Box dangerouslySetInnerHTML={{ __html: about_us }} />
              </Typography>
            </Box>
          </BannerContainer>
          <Box py="24px" height={600} bgcolor="#f9fafb">
            <Grid container columnSpacing={2} columns={24} height="100%">
              <Grid item xs={7} height="100%">
                <img
                  alt="banner"
                  src={publisher_images?.[0]?.image_url}
                  className={classes?.aboutUsImageGallery}
                />
              </Grid>
              <Grid item xs={10}>
                <Grid container rowSpacing={2}>
                  <Grid item xs={12} height={360}>
                    <img
                      alt="banner"
                      src={publisher_images?.[1]?.image_url}
                      className={classes?.aboutUsImageGallery}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Grid container columnSpacing={2} height={190}>
                      <Grid item xs={6} height="100%">
                        <img
                          alt="banner"
                          src={publisher_images?.[2]?.image_url}
                          className={classes?.aboutUsImageGallery}
                        />
                      </Grid>
                      <Grid item xs={6} height="100%">
                        <img
                          alt="banner"
                          src={publisher_images?.[3]?.image_url}
                          className={classes?.aboutUsImageGallery}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={7}>
                <Grid container direction="column" rowGap={2} height="100%">
                  <Grid item height={190}>
                    <img
                      alt="banner"
                      src={publisher_images?.[4]?.image_url}
                      className={classes?.aboutUsImageGallery}
                    />
                  </Grid>
                  <Grid item height={344}>
                    <img
                      alt="banner"
                      src={publisher_images?.[5]?.image_url}
                      className={classes?.aboutUsImageGallery}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box>
          <Box mx="6vw" my="32px">
            <Grid container direction="row" columnSpacing={4}>
              <Grid item xs={12} md={6}>
                {about_us_images?.map(({ image_url }, index) => (
                  <AboutUsImage
                    key={index}
                    image_url={image_url}
                    index={index}
                  />
                ))}
              </Grid>
              <Grid item xs={12} md={6} display="flex" alignItems="center">
                <Box>
                  <Typography fontSize={32} fontWeight={600} mb={1}>
                    About Us
                  </Typography>
                  <Typography color="#687083">
                    <Box dangerouslySetInnerHTML={{ __html: about_us }} />
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Box>
          <Box mx="6vw" my="32px">
            <Grid container direction="row" columnSpacing={4}>
              <Grid item xs={12} md={6} display="flex" alignItems="center">
                <Box>
                  <Typography fontSize={32} fontWeight={600} mb={1}>
                    Our Vision
                  </Typography>
                  <Typography color="#687083">
                    <Box dangerouslySetInnerHTML={{ __html: our_vision }} />
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                {our_vision_images?.map(({ image_url }, index) => (
                  <AboutUsImage
                    key={index}
                    image_url={image_url}
                    index={index}
                  />
                ))}
              </Grid>
            </Grid>
          </Box>
        </>
      )}
    </Layout>
  );
}

const BannerContainer = styled(Box)({
  backgroundImage: `url(${bannerImage})`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  height: "515px",
  display: "flex",
  alignItems: "center",
  padding: "0 64px",
});
